

function StickerItem ({index}) {
    const sticker = ["/Stickers/hcyay.gif", "/Stickers/orpheusBox.png", "/Stickers/starEmoji.png", "/Stickers/strawberryEmoji.png"]

    return(
        <div>
            <img src={sticker[index]} className="h-[100px]" alt=""/>
        </div>
    )
}

export default StickerItem;